import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import {
	type CartaoAmareloFormData,
	cartaoAmareloSchema,
} from '../../schemas/cartao-amarelo-schema'

export function useCartaoAmareloForm() {
	return useForm<
		CartaoAmareloFormData,
		Record<string, never>,
		CartaoAmareloFormData
	>({
		defaultValues: {
			employeeId: '',
			kindId: '',
			riskId: '',
			date: '',
			leaderId: '',
			potential: '',
			unsafeDescription: '',
			safeDescription: '',
			image: undefined,
		},
		resolver: zodResolver(cartaoAmareloSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
